import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Step1 from "./Step1";
import Preview from "./Preview";
import Step2 from "./Step2";
import AddRebid from "../RebidSubmission/AddRebid";

const BidSubmission = () => {
  const [bid, setBid] = useState();
  const [rfq, setRfq] = useState();
  const [workItems, setWorkItems] = useState();
  const [step, setStep] = useState(1);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const { rfqId } = useParams();
  const location = useLocation();
  const [fileNames, setFileNames] = useState({
    attachment1: "",
    attachment2: "",
    attachment3: "",
  });
  const [isRebid, setIsRebid] = useState(
    localStorage.getItem("isRebid") || false
  );

  useEffect(() => {
    const getRFQ = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/rfq/get-by-id?rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setRfq(res.data);
        if (!location.pathname.includes("/draft")){
          setBid({
            ...bid,
            deliveryTerms: res.data.term1,
            paymentTerms: res.data.term2,
            freight: res.data.term3,
            priceBasis: res.data.term4,
            warrantyPeriod: res.data.term5,
            deliveryClause: res.data.term6,
          })
        }
        setWorkItems(
          res.data.rfqWorkItems.map((item) => ({ ...item, rate: 0, total: 0 }))
        );
      } catch (error) {
        console.error(error);
      }
    };
    getRFQ();
  }, [location]);

  useEffect(() => {
    if (location.pathname.includes("/draft")) {
      const getBid = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/draft-bid?vendorId=${vendorId}&rfqId=${rfqId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setBid(res.data);
          setFileNames({
            attachment1: res.data.attachment1Filename,
            attachment2: res.data.attachment2Filename,
            attachment3: res.data.attachment3Filename,
          });
          if (
            res.data.draftBidWorkItems &&
            res.data.draftBidWorkItems.length > 0
          ) {
            const normalizedItems = res.data.draftBidWorkItems.map((item) => ({
              code: item.code,
              description: item.description,
              section: item.section,
              unit: item.unit,
              quantity: item.quantity,
              gst: item.gst,
              rate: item.rate,
              currency: item?.currency?.currency?.shortform,
              total: item.total,
              remark: item.remark
            }));
            setWorkItems(normalizedItems);
          }
        } catch (error) {
          console.error(error);
        }
      };
      getBid();
    }
  }, [location.pathname, rfq]);
  return (
    <div>
      {rfq && (
        <div>
          {step === 1 && (
            <Step1
              rfq={rfq}
              setStep={setStep}
              bid={bid}
              setBid={setBid}
              storedUser={storedUser}
              fileNames={fileNames}
              setFileNames={setFileNames}
            />
          )}
          {step === 2 && isRebid && (
            <AddRebid
              rfq={rfq}
              data={workItems}
              setData={setWorkItems}
              setStep={setStep}
              user={storedUser}
            />
          )}
          {step === 2 && !isRebid && (
            <Step2
              rfq={rfq}
              data={workItems}
              setData={setWorkItems}
              setStep={setStep}
              user={storedUser}
            />
          )}
          {step === 3 && (
            <Preview
              rfq={rfq}
              setStep={setStep}
              bid={bid}
              data={workItems}
              user={storedUser}
              fileNames={fileNames}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default BidSubmission;